import { inject, injectable } from "@launchtray/tsyringe-async";
import { MarketplaceView } from "./view/MarketplaceView";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { IMarketplaceMapModel } from "./models/map/IMarketplaceMapModel";
import { IMarketplaceController } from "./models/controller/IMarketplaceController";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { IMarketplaceViewModel } from "./models/IMarketplaceViewModel";
import { IMarketplaceBuildingModel } from "./models/building/IMarketplaceBuildingModel";
import { IMarketplaceNewsModel } from "./models/news/IMarketplaceNewsModel";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { IBenefitsModel } from "../../../common/models/benefits/IBenefitsModel";
import { IFirstTimeExperienceModel } from "../../../common/models/IFirstTimeExperienceModel";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";
import { CancellationToken } from "async/CancellationToken";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";
import { MarketplaceResourcePackage } from "../resources/MarketplaceResourcePackage";

export type MarketplaceSceneOptions = {
    buildingArea: number;
    cancellationToken: CancellationToken;
}

@injectable()
export class MarketplaceScene extends Viewable<void> {

    public constructor(
        commonResources: CommonResourcesPackage,
        userProfileResources: UserProfileResourcePackage,
        web3Model: Web3Model,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IMarketplaceController") marketplaceController: IMarketplaceController,
        @inject("IMarketplaceMapModel") marketplaceMapModel: IMarketplaceMapModel,
        @inject("IMarketplaceViewModel") marketplaceMapViewModel: IMarketplaceViewModel,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("IMarketplaceBuildingModel") marketplaceBuildingModel: IMarketplaceBuildingModel,
        @inject("IMarketplaceNewsModel") marketplaceNewsModel: IMarketplaceNewsModel,
        @inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper,
        @inject("ILogger") logger: ILogger,
        @inject("IBenefitsModel") benefitsModel: IBenefitsModel,
        @inject("IFirstTimeExperienceModel") firstTimeExperienceModel: IFirstTimeExperienceModel,
        marketplaceResources: MarketplaceResourcePackage,
        @inject("MarketplaceSceneOptions") options: MarketplaceSceneOptions
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new MarketplaceView(
            pcs,
            options.cancellationToken,
            commonResources,
            marketplaceResources,
            userProfileResources,
            canvasScaler,
            marketplaceController,
            marketplaceMapModel,
            marketplaceMapViewModel,
            playerModel,
            marketplaceBuildingModel,
            marketplaceNewsModel,
            options.buildingArea,
            analyticsProvider,
            benefitsModel,
            firstTimeExperienceModel,
            logger,
            web3Model
        );
        pcs.result.then(() => {
            this.operationControls.complete();
            userProfileResources.destroy();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        })
    }
}
